import React from 'react'
import { type Column } from './taskAdmin.utils'

interface TasksTableSkeletonProps {
  visibleColumns: Column[]
  rowCount?: number
}

const SkeletonBar: React.FC<{ width?: string; height?: string }> = ({ 
  width = 'w-full', 
  height = 'h-4' 
}) => (
  <div className={`${width} ${height} bg-secondary/10 rounded animate-pulse`} />
)

const SkeletonRow: React.FC<{ visibleColumns: Column[] }> = ({ visibleColumns }) => (
  <tr className="hover:bg-secondary/5">
    {visibleColumns.map((column) => (
      <td key={column.key} className="px-6 py-4 whitespace-nowrap">
        {(() => {
          // Customize skeleton based on column type
          const columnSkeletons = {
            name: <SkeletonBar width="w-32" height="h-4" />,
            teaser: <SkeletonBar width="w-40" height="h-4" />,
            body: <SkeletonBar width="w-48" height="h-4" />,
            difficulty: <SkeletonBar width="w-20" height="h-6" />,
            description: <SkeletonBar width="w-40" height="h-4" />,
            accessGroups: <SkeletonBar width="w-28" height="h-4" />,
          }
          
          return columnSkeletons[column.key as keyof typeof columnSkeletons] || <SkeletonBar />
        })()}
      </td>
    ))}
  </tr>
)

export const TasksTableSkeleton: React.FC<TasksTableSkeletonProps> = ({
  visibleColumns,
  rowCount = 5
}) => {
  return (
    <>
      {Array.from({ length: rowCount }, (_, index) => (
        <SkeletonRow key={`skeleton-row-${index}`} visibleColumns={visibleColumns} />
      ))}
    </>
  )
}
